const getDefaultCurrency = () => {
  if (typeof navigator !== 'undefined' && navigator.language) {
    const lang = navigator.language.toLowerCase();
    if (
      lang.startsWith('en-gb') ||
      lang.startsWith('en-ie') ||
      lang.startsWith('cy-') ||
      lang.startsWith('gd-') ||
      lang.startsWith('ga-')
    ) {
      return 'gbp';
    }
    if (
      lang.startsWith('fr') ||
      lang.startsWith('de') ||
      lang.startsWith('es') ||
      lang.startsWith('it') ||
      lang.startsWith('pt') ||
      lang.startsWith('nl') ||
      lang.startsWith('fi') ||
      lang.startsWith('sv') ||
      lang.startsWith('da') ||
      lang.startsWith('no') ||
      lang.startsWith('el') ||
      lang.startsWith('et') ||
      lang.startsWith('lv') ||
      lang.startsWith('lt') ||
      lang.startsWith('pl') ||
      lang.startsWith('sk') ||
      lang.startsWith('sl') ||
      lang.startsWith('cs') ||
      lang.startsWith('hu') ||
      lang.startsWith('hr') ||
      lang.startsWith('bg') ||
      lang.startsWith('ro') ||
      lang.startsWith('mt') ||
      lang.startsWith('eu-') // Basque
    ) {
      return 'eur';
    }
  }
  return 'usd';
};

export { getDefaultCurrency };
